export const forgot = {
	type: 'object',
	required: ['email'],
	properties: {
		email: {
			type: 'string',
			format: 'email',
			minLength: 1,
			maxLength: 255
		}
	}
};
